import React, { useContext } from 'react';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { UserContext } from '../../../context/UserContext';

const Drawer = ({ active, setActive }) => {
	const { t } = useTranslation();
	const { user } = useContext(UserContext);

	const navigation = [
		{
			href: t('navigation.href.map'),
			label: t('navigation.label.map'),
			icon: 'map',
		},
		{
			href: t('navigation.href.illegal_waste_dumps_list'),
			label: t('navigation.label.illegal_waste_dumps_list'),
			icon: 'list',
		},
		{
			href: t('navigation.href.settings'),
			label: t('navigation.label.settings'),
			icon: 'user',
		},
	];

	if (user?.roles?.includes('admin', 'advanced_user')) {
		navigation.splice(2, 0, {
			href: t('navigation.href.user_management'),
			label: t('navigation.label.user_management'),
			icon: 'avatars',
		});
	}

	return (
		<aside className={active ? 'is-active' : ''}>
			<button className="button" onClick={() => setActive(!active)}>
				<i className="icon fz-menu" />
			</button>

			<div className="menu is-menu-main">
				<ul className="menu-list">
					{navigation.map((navLink) => (
						<li key={navLink.href}>
							<NavLink to={`/${navLink.href}`}>
								{navLink?.icon && (
									<span className="icon">
										<i className={`fz-${navLink.icon}`} />
									</span>
								)}
								<span className="menu-item-label">{navLink.label}</span>
							</NavLink>
						</li>
					))}
				</ul>
			</div>
		</aside>
	);
};

export default Drawer;
